import React, { useState } from 'react';
import Popup from '../../ui/Popup';
import DragAndDrop, { InitialItems } from './dragAndDrop';
import i18n from '../../utils/i18n';
import { PopupSize } from '../../ui/Popup/Popup';
import GridRow from '../../ui/GridRow';
import GridCol from '../../ui/GridCol';
import Button from '../../ui/Button';
import { ButtonVariationEnum } from '../../ui/Button/types';
import s from './styles/dragAndDrop.module.scss';

interface IDragAndDropPopup {
    isOpen: boolean;
    handleClose: () => void;
    items?: Array<InitialItems>;
    submit: (arg: Array<{ id: number; order: number }>) => Promise<boolean>;
}

const DragAndDropPopup = ({ isOpen, handleClose, items = [], submit }: IDragAndDropPopup) => {
    const [listItems, updateItemsList] = useState<Array<InitialItems>>(items);
    const [isPending, startTransition] = useState<boolean>(false);

    if (!isOpen) {
        return null;
    }

    const handleSave = async () => {
        if (!listItems?.length) {
            handleClose();
        }

        startTransition(true);

        const response = await submit(
            listItems.map((item, idx) => ({
                id: item.id,
                order: idx + 1,
            })),
        );

        if (response) {
            handleClose();
        } else {
            startTransition(false);
        }
    };

    return (
        <Popup title={i18n.general.sort} close={handleClose} size={PopupSize.m}>
            <GridRow column gutter={8}>
                <GridCol col={12} className={s.wrapper}>
                    <DragAndDrop itemsList={listItems} updateItemsList={updateItemsList} />
                </GridCol>
                <GridCol col={12}>
                    <GridRow gutter={8}>
                        <Button onClick={handleSave} isLoading={isPending}>
                            {i18n.general.save}
                        </Button>
                        <Button variation={ButtonVariationEnum.SOFT} onClick={handleClose}>
                            {i18n.general.reset}
                        </Button>
                    </GridRow>
                </GridCol>
            </GridRow>
        </Popup>
    );
};

export default DragAndDropPopup;
